import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { Button } from "../button/Button";
import { Icon } from "../icon/Icon";
export var HudOptionButton = function (_a) {
    var children = _a.children, onClick = _a.onClick, disabled = _a.disabled, icon = _a.icon, orientation = _a.orientation;
    return (React.createElement(Button, { onClick: onClick, className: "hud-options-button flex flex--guts", disabled: disabled },
        React.createElement(Icon, { icon: icon, styleId: IdStyles.IconSmall, orientation: orientation })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/hud-option-button/HudOptionButton.tsx
// module id = 592
// module chunks = 3